import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import TextInputField from "../components/TextInputField";

//TODO: remove username from user schema and signup form
export default function Signup() {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState({
    email: "",
    username: "",
    password: "",
  });
  const displaySignupFields = ["email", "username", "password"];
  const signupFieldTypes = {"email":"email", "username":"text", "password":"password"};

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  const handleError = (err) =>
    toast.error(err, {
      position: "bottom-left",
    });
  const handleSuccess = (msg) =>
    toast.success(msg, {
      position: "bottom-right",
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/signup`,
        {
          ...inputValue,
        },
        { withCredentials: true }
      );
      const { success, message } = data;
      console.log(data);
      if (success) {
        handleSuccess(message);
        setTimeout(() => {
          navigate("/credentials");
        }, 1000);
      } else {
        handleError(message);
      }
    } catch (error) {
      console.log(error);
    }
    setInputValue({
      ...inputValue,
      email: "",
      password: "",
      username: "",
    });
  };

  return (
    <div className="container" align="center">
      <h1>Signup</h1>
      <ul>
        {displaySignupFields.map((key) => (
          <li key={key}>
            <TextInputField
              displayName={key}
              name={key}
              type={signupFieldTypes[key]}
              value={inputValue[key]}
              isEditable={true}
              nameValueInterPadding={()=> {return key === "username"? 0 : 1}}
              onChange={handleOnChange}
              onKeyUp={(e) => {
                e.key === "Enter" && console.log(inputValue);
              }}
            />
          </li>
        ))}
      </ul>
      <button onClick={handleSubmit}>Submit</button>
      <br />
      <br />
      <span>
        Already have an account? <Link to={"/login"}>Login</Link>
      </span>
      <ToastContainer />
    </div>
  );
}
